import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

interface ReferralSettings {
  isActive: boolean;
  reward: number;
  maxReferrals: number;
  lastUpdated: Date;
}

export function useReferralSettings() {
  const [settings, setSettings] = useState<ReferralSettings>({
    isActive: false,
    reward: 50,
    maxReferrals: 100,
    lastUpdated: new Date()
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'settings', 'referral'), (doc) => {
      if (doc.exists()) {
        setSettings({
          isActive: doc.data().isActive ?? false,
          reward: doc.data().reward ?? 50,
          maxReferrals: doc.data().maxReferrals ?? 100,
          lastUpdated: doc.data().lastUpdated?.toDate() ?? new Date()
        });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { settings, loading };
} 